var _path, _rect, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMaasLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 37C28.7173 37 37 28.7173 37 18.5C37 8.28273 28.7173 0 18.5 0C8.28273 0 0 8.28273 0 18.5C0 28.7173 8.28273 37 18.5 37Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12.7185,
    y: 10.4062,
    width: 17.3438,
    height: 9.25,
    rx: 4.625,
    stroke: "#528FF0",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2024 15.3203H12.7185C9.68525 15.3203 7.22632 17.7792 7.22632 20.8125C7.22632 23.8458 9.68525 26.3047 12.7185 26.3047H20.8123C23.8455 26.3047 26.3044 23.8458 26.3044 20.8125C26.3044 20.4249 26.2643 20.0468 26.1879 19.6819C25.9778 19.7216 25.7609 19.7424 25.5392 19.7424H24.4155C24.5161 20.0816 24.5701 20.4407 24.5701 20.8125C24.5701 22.8879 22.8876 24.5703 20.8123 24.5703H12.7185C10.6431 24.5703 8.96069 22.8879 8.96069 20.8125C8.96069 18.7371 10.6431 17.0547 12.7185 17.0547H13.2907C13.2329 16.8037 13.2024 16.5422 13.2024 16.2737V15.3203Z",
    fill: "#528FF0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaasLogo);
export default __webpack_public_path__ + "static/media/maasLogo.8139a64ca2e4182747622aaefd4cca4b.svg";
export { ForwardRef as ReactComponent };